var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M268.361,201.452h-22.971H76.935H53.963H30.993v76.571c0,24.597,15.662,47.653,42.972,63.259 c23.662,13.522,54.629,20.968,87.197,20.968s63.535-7.447,87.197-20.968c27.308-15.605,42.972-38.663,42.972-63.259v-76.571H268.361 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003778"
    },
    d: "M268.361,201.452h-22.971h-84.228V362.25c32.568,0,63.535-7.447,87.197-20.968 c27.308-15.605,42.972-38.663,42.972-63.259v-76.571H268.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006DF0"
    },
    d: "M268.361,124.882h-22.971H76.935H53.963H30.993v76.571c0,24.597,15.662,47.653,42.972,63.26 c23.662,13.52,54.629,20.968,87.197,20.968s63.535-7.447,87.197-20.968c27.308-15.607,42.972-38.663,42.972-63.26v-76.571H268.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M268.361,124.882h-22.971h-84.228v160.798c32.568,0,63.535-7.447,87.197-20.968 c27.308-15.605,42.972-38.662,42.972-63.259v-76.571H268.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93C7EF"
    },
    d: "M248.36,61.623c-23.662-13.522-54.629-20.968-87.197-20.968s-63.535,7.447-87.197,20.968 c-27.31,15.605-42.972,38.663-42.972,63.259s15.662,47.653,42.972,63.259c23.662,13.522,54.629,20.968,87.197,20.968 s63.535-7.447,87.197-20.968c27.308-15.604,42.972-38.662,42.972-63.259S275.668,77.228,248.36,61.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B9EB"
    },
    d: "M248.36,61.623c-23.662-13.522-54.629-20.968-87.197-20.968V209.11 c32.568,0,63.535-7.447,87.197-20.968c27.308-15.605,42.972-38.663,42.972-63.26S275.668,77.228,248.36,61.623z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5023"
    },
    d: "M421.501,151.499H384.31c0-30.761-25.027-55.787-55.787-55.787V58.521 C379.79,58.521,421.501,100.231,421.501,151.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5023"
    },
    d: "M92.978,455.228C41.71,455.228,0,413.517,0,362.25h37.191c0,30.761,25.026,55.787,55.787,55.787 V455.228z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AED5F3"
    },
    d: "M512,387.769c0-35.984-24.052-68.756-58.491-79.696l-12.321-3.914l-0.622-12.914 c-2.838-58.897-51.286-105.033-110.297-105.033c-52.634,0-98.204,37.467-108.353,89.086l-2.499,12.71l-12.788,2.062 c-43.762,7.053-76.763,45.77-76.763,90.057c0,50.297,40.922,91.219,91.219,91.219h207.34C474.509,471.344,512,433.852,512,387.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93C7EF"
    },
    d: "M453.509,308.072l-12.321-3.914l-0.622-12.914c-2.838-58.897-51.286-105.033-110.297-105.033 c-3.511,0-6.986,0.179-10.423,0.505v284.629h108.58c46.084,0,83.575-37.493,83.575-83.576 C512,351.784,487.948,319.013,453.509,308.072z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigData);
export default __webpack_public_path__ + "static/media/BigData.a22dbf1fa43be9fd16cde372674dfda6.svg";
export { ForwardRef as ReactComponent };